import { primaryKeyFromContext } from 'app/area/case/selectors';
import { CaseState } from 'app/area/case/types-store';

export const connectedPkFromContext = (state: CaseState, uiEngineProps: any) => {
  const { pk } = primaryKeyFromContext('pk')(state, uiEngineProps);
  const { componentDescriptor } = uiEngineProps;
  const connectedPkValueTag = componentDescriptor.properties.connectedPkValueTag;

  return {
    initialValues: {
      [connectedPkValueTag]: [pk]
    }
  };
};
